import { LanguageCode, StringEnumSchema } from '@flysas-tech/book-value-stream-models';
import { Static, Object, Optional } from '@sinclair/typebox';

import { AirportPartners, CityMap } from '../../sas-domain/airports';

export const RevenueLocationsQueryParams = Object({
  partner: Optional(StringEnumSchema(AirportPartners)),
  languageCode: Optional(StringEnumSchema(LanguageCode)),
});
export type RevenueLocationsQueryParams = Static<typeof RevenueLocationsQueryParams>;

export const RevenueLocationsResponse = CityMap;
export type RevenueLocationsResponse = Static<typeof RevenueLocationsResponse>;
